const theme = {
    // COLORS THEME
    colors: {
        primary: "#4361ee",
        secondary: "#b5179e",
    },
    
    size: {
    sm: {
        fontSize: "0.8rem",
        padding: "0.2rem 0.5rem",
    },
    lg: {
        fontSize: "1.3rem",
        padding: "0.5rem 1rem",
    },
    md: {
        fontSize: "1rem",
        padding: "0.8rem 1.6rem",
    },
    }
};

export default theme;